<template>
  <div class="px-1 rounded pb-2">
    <TitleButton
        class="mt-1"
        :showBtn="false"
        :showAddNew="false"
        title="Budget Setup"
    >
      <template #extra-btn>
        <div v-if="hasSheet" class="d-flex flex-wrap justify-content-end gap-1">
          <button type="button" class="btn btn-outline-primary btn-sm text-nowrap" :disabled="isExporting" @click="emit('handleExport')">
            <i class="fas fa-download me-50"></i> Export Excel
          </button>
          <button v-if="props.canImport !== false" type="button" class="btn btn-primary btn-sm text-nowrap" @click="emit('handleImport')">
            <i class="fas fa-upload me-50"></i> Import Excel
          </button>
        </div>
      </template>
    </TitleButton>

    <div class="row gy-1">
      <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-12">
            <ul class="nav nav-tabs" role="tablist">
              <li
                  class="nav-item"
                  :class="`${props.accountType == tab.id ? 'active' : ''}`"
                  v-for="(tab, i) in tabs"
                  :key="i"
                  @click="onClickTab(tab.id)"
                  type="button"
              >
                <a :class="`${props.accountType == tab.id ? 'active' : ''}`" class="nav-link" data-bs-toggle="tab"
                   aria-controls="home" role="tab" aria-selected="true">{{ tab.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>

  </div>

  <div class="card-body">
    <div class="row d-flex flex-wrap justify-content-between align-items-center">
      <TreeBrowser
          :style="{opacity: chartLoading ? .5 : 1}"
          :groupData="groupData"
          :endpointData="endpointData"
          :depth="0"
          :accountType="props.accountType"
          :fetchTree="props.fetchTree"
          @paginationEmit="handlePaginationEmit"
      />
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import TreeBrowser from "./TreeBrowser";
import TitleButton from '@/components/atom/TitleButton'
import handleInventory from "@/services/modules/inventory";

const emit = defineEmits(['handleTabChange', 'handleRootPagination', 'handleExport', 'handleImport'])
const props = defineProps(['tabs', 'groupData', 'endpointData', 'accountType', 'isExporting', 'fetchTree', 'canImport'])
const {chartLoading} = handleInventory();
const sheetTabs = ['item', 'account', 'activity_budget', 'activity_target'];
const hasSheet = computed(() => sheetTabs.includes(props.accountType));

function onClickTab(tab) {
  emit('handleTabChange', tab)
}

function handlePaginationEmit(page) {
  emit('handleRootPagination', page)
}

</script>